import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

/**
 * 判断clickSpid对应的元素是不是触发器
 * @param control 演示态redux store中的数据
 * @param clickSpid 所点击元素或者当前元素的clickSpid
 * @returns boolean
 */
export const isInteractiveAnimClick = (control: {[key: string]: any}, clickSpid: string): boolean => {
    if (!control || !clickSpid) return false;
    const { iaFragmentLengthInfos = {}, currentPage = 0 } = control;
    const iaIdMap = iaFragmentLengthInfos[currentPage] || {};
    const iaIdList = Object.keys(iaIdMap);
    if (!iaIdList.includes(clickSpid)) return false;

    return true;
};

/**
 * 判断元素是否为可点击元素
 * @returns boolean
 */
export const checkClickElement = (factoryOptions: InterfaceFactoryOptions<IElementBaseModel>): boolean => {
    const { model: { props, id } = {}, getPlayerReduxStore } = factoryOptions;
    if (hasMedia(factoryOptions.model)) {
        return true;
    }
    // 链接以及触发器元素光标需要展示为pointer
    const isAnimTrigger = isInteractiveAnimClick(getPlayerReduxStore?.()?.getState()?.control, id ?? '');
    return !!(props?.link?.href) || isAnimTrigger;
};


// 判断uiModel是否为音视频或者组合中是否含有音视频
export const hasMedia = (model): boolean => {
    if (model.type === UIModelType.IMAGE) {
        return !!model.video || !!model.audio;
    }

    if (model.type === UIModelType.GROUP) {
        return model.children.some(childModel => hasMedia(childModel));
    }

    return false;
};
